import React, {useState} from 'react';
import '../App.css';
import Fuse from 'fuse.js';
import { useTranslation } from 'react-i18next';
import { SearchBox, Stack } from '@fluentui/react/lib';
import { tFilterObject, tActiveFilters } from '../types/typedefinitons';

const SearchInput: React.FC<{rawData:{[key:string]:any}, searchAction?:any, fuseOptions:{}, setSelectedValues:(action:string, changedValue?:tFilterObject) => void, selectedValues:tActiveFilters, view?:string, disabled:boolean}> = (props) => {
    const {rawData, searchAction, fuseOptions,setSelectedValues, selectedValues, view, disabled} = props;
    const defaultArrayState:{}[] = [];
    const [dropdownResults, setDropdownResults] = useState(defaultArrayState);
    const [dropdownVisibility,setDropdownVisibility] = useState('hidden');
    const [searchValue, setSearchValue] = useState<string>();
    const {t} = useTranslation();
    let searchArray:any[] = [];

    if(Object.keys(rawData).length > 0){
      searchArray = [...Object.values(rawData.media), ...rawData.materials];
    }

    const handleSearchInput = (event:any) => {
        let targetInput = '';
        if(event){
          targetInput = event.target.value;
        }
    
        setSearchValue(targetInput);

        const fuse2 =  new Fuse(searchArray, fuseOptions);
        const searchResult = fuse2.search(targetInput);
        let matchCheck:{[key:string]:string[]} = {'Medium':[]};
        let dropdownOptions:{[key:string]:{}|undefined}[] = [];
    
       
        for(let resultItem in searchResult){
          const searchResultItem:any = searchResult[resultItem];
          let checkValue = '';
          if(searchResultItem.matches.length > 0 ){
            searchResultItem.matches.forEach((resultItemMatch:{key:string, value:string}) => {
              const resultKey = resultItemMatch.key;
              const resultValue = resultItemMatch.value;
              let row1 = '';
              let row2 = '';
              let filterValue = '';
              let shouldAddOption = false;
              let filterData = undefined;
              let filterDataSpecificSearch = undefined;
              let filterKeys:string[] = [];
              let displayValue = '';
              let resultType = 'medium';
              if(matchCheck[resultKey] === undefined){
                  matchCheck[resultKey] = [];
              }

              switch(resultItemMatch.key){
                  case 'Medium':
                  case 'Alternative_Namen':
                  case 'Medium_alt':
                  case 'Alternative_Namen_alt':
                  case 'searchString':
                  case 'Anmerkung':
                  case 'Anmerkung_alt':
                  case 'Formel':
                  case 'CAS_Nr':
                          if(resultKey === 'Medium'){
                            checkValue = resultValue + (searchResultItem.item.Zustand ? '_'  + searchResultItem.item.Zustand : '');
                          }
                          else if (resultKey === 'Alternative_Namen' || resultKey === 'Alternative_Namen_alt' || resultKey === 'Medium_alt' || resultKey === 'searchString' || resultKey === 'Formel' || resultKey === 'CAS_Nr'){
                            checkValue = searchResultItem.item.Medium + (searchResultItem.item.Zustand ? '_'  + searchResultItem.item.Zustand : '');
                          }

                          if(matchCheck['Medium'].indexOf(checkValue) === -1){
                              shouldAddOption = true;
                              matchCheck['Medium'].push(checkValue);
                              row1 = searchResultItem.item.Medium + (searchResultItem.item.Zustand ? ' | '  + searchResultItem.item.Zustand : '') + (searchResultItem.item.Formel ? ' | '  + searchResultItem.item.Formel : '');
                              row2 = (searchResultItem.item.Alternative_Namen ? searchResultItem.item.Alternative_Namen : '') + (searchResultItem.item.Alternative_Namen &&  searchResultItem.item.CAS_Nr ? ' | ' : '') + (searchResultItem.item.CAS_Nr ? t('table.head.CAS_Nr') + ':' + searchResultItem.item.CAS_Nr : '');
                              filterValue = checkValue.replace(/_/,' | ');
                          }
                         filterData = [{Medium: searchResultItem.item.Medium}, {Zustand: searchResultItem.item.Zustand}]
                         filterDataSpecificSearch = {Medium: searchResultItem.item.Medium, Zustand: searchResultItem.item.Zustand};
                         if(resultKey === 'Anmerkung' || resultKey === 'Anmerkung_alt'){
                          row2 = searchResultItem.item.Anmerkung
                         }

                      break;
                  case 'materialArray.name':
                    if(matchCheck[resultKey].indexOf(resultValue) === -1){
                      shouldAddOption = true;
                      matchCheck[resultKey].push(resultValue);
                      row1 = resultItemMatch.value;
                      filterKeys = [resultValue];
                      filterValue = '+';
                      displayValue = resultValue;
                      resultType = 'material';
                    }

                    
                    break;
                  default:
                        checkValue = resultKey + '_' + resultValue;
                      if(matchCheck[resultKey].indexOf(checkValue) === -1){
                          shouldAddOption = true
                          matchCheck[resultKey].push(checkValue);
                          filterValue = resolveObj(resultItemMatch.key, searchResultItem.item)
                          row1 = filterValue;
                      }
                    
                      
              }
              if(shouldAddOption)
                  dropdownOptions.push({filterKeys:filterKeys,row1:row1, row2:row2, filterValue: filterValue, displayValue:displayValue, filterData:filterData, filterDataSpecificSearch:filterDataSpecificSearch, resultType:resultType})
            });
          }
          else{
            checkValue = searchResultItem.item.Medium + (searchResultItem.item.Zustand ? '_'  + searchResultItem.item.Zustand : '');
            let row1 = '';
            let row2 = '';
            let filterValue = '';
            if(matchCheck['Medium'].indexOf(checkValue) === -1){
              matchCheck['Medium'].push(checkValue);
              row1 = searchResultItem.item.Medium + (searchResultItem.item.Zustand ? ' | '  + searchResultItem.item.Zustand : '') + (searchResultItem.item.Formel ? ' | '  + searchResultItem.item.Formel : '');
              row2 = searchResultItem.item.Alternative_Namen;
              filterValue = checkValue.replace(/_/,' ');
              dropdownOptions.push({filterKey:'Medium',row1:row1, row2:row2, filterValue: filterValue})
          }
          }

        }
        // console.log('HIER -------------------------------------')
        // console.log(matchCheck)
        // console.log(dropdownOptions)
        if(targetInput === ''){
          setDropdownResults([]);
          setDropdownVisibility('hidden');
        }
        else if(dropdownOptions.length > 0){
          setDropdownVisibility('');
          setDropdownResults(dropdownOptions);
        } 
        else{
          setDropdownResults([]);
          setDropdownVisibility('hidden');
        }
      }

      var timeoutState:any = null;
      const handleDropdownState = (event:any) => {
        const eventType = event.type;
        if(eventType === 'mouseleave')
          timeoutState = setTimeout(function(){setDropdownVisibility('hidden')},1000);
        if(eventType === 'mouseover'){
          clearTimeout(timeoutState);
          setDropdownVisibility('');
        }
    
      }
     
      const filterElements = Object.keys(selectedValues).map((key) => {
          return (
            <div>
            {/* {selectedValues[key as 'material'|'medium'].length > 0 ? <span className="gemu-rs-filter-element removable">{t('labels.'+key)}</span> : null} */}
            {selectedValues[key as 'material'|'medium'].map((value, vIndex) => {
              return(
                <span key={'as-'+vIndex} className="gemu-rs-filter-element removable" onClick={()=>{setSelectedValues('remove',value)}}>{(value.displayValue ? value.displayValue:value.filterValue)}</span>
              )
            })}
            </div>
           
          )
        });
        // console.log('Values', selectedValues)

    return(
      <>
        <div className="gemu-rs-searchWrapper">
          <Stack horizontal tokens={{childrenGap:0}}>
            <Stack.Item grow={2}>
              <SearchBox 
                placeholder={t('placeholder.search')} 
                onSearch={newValue => console.log('value is ' + newValue)}
                onChange = {handleSearchInput}
                value={searchValue}
                disabled={disabled}
              />
            </Stack.Item>
            {/* <Stack.Item grow={1}>
              <DefaultButton 
              text={t('buttons.search')} 
              onClick={(e) => searchAction(e, {filterValue:searchValue, filterSource:'text'})} 
              allowDisabledFocus
              tabIndex={-1}
              />
            </Stack.Item> */}
          </Stack>
        <div className={"gemu-rs-custom-dropdown " + dropdownVisibility} onMouseLeave={handleDropdownState} onMouseOver={handleDropdownState}>
              <ul className="gemu-rs-search-result-list">
            {dropdownResults? dropdownResults.map((value:any, index:number) => {
              if(index < 7){
                return(
                  <li tabIndex={0} key={'dropdown-option-' + index} onClick={(e) => {setDropdownVisibility('hidden');setSelectedValues('set',value); setSearchValue('')}}>
                    <span>{value.row1}</span><br/>
                    <span className="gemu-rs-search-result-list-small">{value.row2}</span>
                  </li>)
              }
              else{
                return null;
              }
              })
              : <li></li>
            }
          </ul>
      </div>
      </div>
      <div>
        {filterElements.length > 0 && view === 'classic' ?
        <>
        {filterElements}
        </>
        :
        null
        }
      </div>
      
      </>
    )

}

function resolveObj(path:string, obj:{}) {
    return path.split('.').reduce(function(prev:any, curr) {
        return prev ? prev[curr] : null
    }, obj)
  }

export default SearchInput;